export default __webpack_public_path__ + "static/media/installation_safari3.7864bb0e.png";